import { render, staticRenderFns } from "./ktoTC.vue?vue&type=template&id=124256fd&scoped=true&"
import script from "./ktoTC.vue?vue&type=script&lang=js&"
export * from "./ktoTC.vue?vue&type=script&lang=js&"
import style0 from "./ktoTC.vue?vue&type=style&index=0&id=124256fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124256fd",
  null
  
)

export default component.exports